import React from 'react';
import NavBar from './NavBar';
import SideBar from './SideBar';
import Processando from './Processando';
import FornecedoresChatbot from './FornecedoresChatbot';
import Breadcrumb from './Breadcrumb';
import { getAuthPerfil } from '../util/authSession';

import 'semantic-ui-css/semantic.min.css';
import '../css/bootstrap.css';
import '../css/app.css';
import '../css/custom.css';

const CHATBOT_PERFIS = ['evento', 'gerenteevento', 'admin', 'diretor'];
// Chat "Banco de Fornecedores" desligado em todo o sistema a pedido do Rafael (05/10: o balão cobria botões
// das telas). O componente fica; para religar numa tela, passe chatbot={true} no ErpTemplate dela.

export default function ErpTemplate({ children, sidebar = true, processando = false, idioma = 'portugues', espacoFinal = 100, chatbot = false }) {
    const perfil = getAuthPerfil();
    const [menuRecolhido, setMenuRecolhido] = React.useState(() => {
        try { return localStorage.getItem('menuRecolhido') === '1'; } catch (e) { return false; }
    });
    const toggleMenu = () => setMenuRecolhido((prev) => {
        const novo = !prev;
        try { localStorage.setItem('menuRecolhido', novo ? '1' : '0'); } catch (e) { /* ignore */ }
        return novo;
    });
    const larguraMenu = sidebar === true ? (menuRecolhido ? 75 : 230) : 0;
    React.useEffect(() => {
        try { document.documentElement.style.setProperty('--access-sidebar-w', larguraMenu + 'px'); } catch (e) { /* ignore */ }
    }, [larguraMenu]);

    return (
        <>
            <NavBar />
            {sidebar === true ? <SideBar recolhido={menuRecolhido} onToggle={toggleMenu} /> : null}
            <div id="main" style={{ marginLeft: larguraMenu + "px", marginTop: "50px" }}>
                <Breadcrumb />
                {children}
                {espacoFinal > 0 && <div style={{ height: espacoFinal + "px" }}></div>}
                {processando && <Processando idioma={idioma} />}
            </div>
            {chatbot && CHATBOT_PERFIS.includes(perfil) && <FornecedoresChatbot />}
        </>
    );
}
